import Keyboard from "./keyboard";
import Tiles from "./tiles";

const Main = () => {
  return (
    <div className="main">
      <Tiles />
      <Keyboard />
    </div>
  );
};

export default Main;
